import React from "react"
import footerStyle from './footer.module.css';
export default function Footer(props) {
    return <footer>
        <div className={footerStyle.container}>
            <div>
                <a href="https://twitter.com/vi5halR" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a href="https://github.com/rajputvishal" target="_blank" rel="noopener noreferrer">GitHub</a>
                <a href="https://www.linkedin.com/in/rajputvishal/" target="_blank" rel="noopener noreferrer">Linked In</a>
            </div>    
            <div className={footerStyle.copyright}>Copyright © 2020. All rights reserved.</div>
        </div>
    </footer>
}